import {DataSource} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {CallLogEntryModel} from '@app/models/call-log-entry.model';
import {BehaviorSubject, from, merge, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class CallLogDataSource extends DataSource<any> {
  private readonly filterChange = new BehaviorSubject('');
  get filter(): string {
    return this.filterChange.value;
  }
  set filter(filter: string) {
    this.filterChange.next(filter);
  }

  constructor(private callLog: CallLogEntryModel[], private sort: MatSort, private paginator: MatPaginator) {
    super();
  }

  connect(): Observable<CallLogEntryModel[]> {
    const displayDataChanges = [this.filterChange, from(this.callLog), this.sort.sortChange, this.paginator.page];

    return merge(...displayDataChanges).pipe(
      map(() => {
        const data = this.getSortedData().slice();

        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        return data.splice(startIndex, this.paginator.pageSize).filter((entry: CallLogEntryModel) => {
          const caller: string = entry.caller + entry.fullNumber;
          return caller.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase());
        });
      })
    );
  }

  disconnect() {}

  getSortedData(): CallLogEntryModel[] {
    const data = this.callLog.slice();
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this.sort.active) {
        case 'time':
          // at runtime callStart is unix timestamp and not a Date
          [propertyA, propertyB] = [a.callStart, b.callStart];
          break;
        case 'caller':
          [propertyA, propertyB] = [a.fullNumber, b.fullNumber];
          break;
        case 'duration':
          [propertyA, propertyB] = [a.duration, b.duration];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this.sort.direction === 'asc' ? 1 : -1);
    });
  }
}
